import React from "react";
import bonus from "../../components/tarik.jpeg";

function Tarik() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>Real Estate with Tarik</h1>
          <p>
            <a href="https://docs.google.com/presentation/d/1EjFxjA2WJzDRocRPmLqFBuigqWaTwd9nSAGEiB2zVi0/edit?usp=sharing">
              View Presentation Here!
            </a>
          </p>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default Tarik;
